const EMOJI_ONLY =
  /^(?:(?:\p{Extended_Pictographic}\uFE0F|(?=\p{Extended_Pictographic})\p{Emoji_Presentation}\uFE0F?)\p{Emoji_Modifier}?(?:\u200D(?:\p{Extended_Pictographic}\uFE0F|(?=\p{Extended_Pictographic})\p{Emoji_Presentation}\uFE0F?)\p{Emoji_Modifier}?)*|\p{Regional_Indicator}{2}|[0-9#*]\uFE0F?\u20E3)+$/u;

export function isEmojiOnlyMessage(value: unknown): boolean {
  return typeof value === 'string' && EMOJI_ONLY.test(value.replace(/\s/g, ''));
}
